import React from "react";

import cx from "classnames";

import styles from "./Link.module.css";

type LinkProps = React.HTMLProps<HTMLAnchorElement> & React.AnchorHTMLAttributes<HTMLAnchorElement>;

export default class Link extends React.Component<LinkProps> {
	render() {
		const { className, ...rest } = this.props;
		return <a {...rest} className={cx(styles.link, className)} />;
	}
}

interface ButtonLinkProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	color?: string;
}
declare module "csstype" {
	interface Properties {
		/** Our CSS variables */
		"--button-link-color"?: string;
	}
}

/**
 * A component that looks like a link, but is actually a button.
 *
 * This should be avoided where possible, as it's bad practice to mislead users
 * about how this UI element works. However, designs are designs, so this exists.
 * @see {@link https://www.w3.org/TR/wai-aria-practices/#h-note | the WAI-Aria Authoring Practices}
 * for more details on why not to do this.
 */
export const ButtonLink = React.forwardRef<HTMLButtonElement, ButtonLinkProps>(function ButtonLink(
	{ className, type = "button", color = "initial", ...rest },
	ref,
) {
	return (
		<button
			type={type}
			className={cx(styles.buttonLink, className)}
			style={{ "--button-link-color": color }}
			{...rest}
			ref={ref}
		/>
	);
});
